import { useId } from "react";

export const WinterfellRoundTower = ({
  x,
  y,
  width,
  height,
  levels = 2,
  nightAmount,
}: {
  x: number;
  y: number;
  width: number;
  height: number;
  levels?: number;
  nightAmount: number;
}) => {
  /* React Hooks */
  const stoneId = useId();

  /* Helpers */
  const roofs = Array.from({ length: levels }, (_, index) => ({
    width: width * (0.6 + index * 0.23),
    y: index * height * 0.23,
  }));

  /* Render */
  const render = () => (
    <g transform={`translate(${x} ${y})`}>
      <defs>
        <linearGradient id={stoneId}>
          <stop stopColor="#293c4d" />
          <stop offset="0.35" stopColor="var(--yard-farHill)" />
          <stop offset="1" stopColor="#253646" />
        </linearGradient>
      </defs>
      <path
        d={`M${-width * 0.32} 0H${width * 0.32}V${height}H${-width * 0.32}Z`}
        fill={`url(#${stoneId})`}
      />
      <path
        d={`M${-width / 2} ${height * 0.42}Q0 ${height * 0.37} ${width / 2} ${height * 0.42}V${height}Q0 ${height + 15} ${-width / 2} ${height}Z`}
        fill={`url(#${stoneId})`}
        stroke="#344959"
        strokeWidth="1.5"
      />
      {Array.from({ length: 7 }, (_, index) => (
        <path
          key={index}
          d={`M${-width * 0.47} ${height * 0.47 + index * height * 0.075}q${width * 0.47} 10 ${width * 0.94} 0`}
          fill="none"
          stroke="#152a3a"
          strokeWidth="1"
          opacity="0.22"
        />
      ))}
      {[-0.2, 0.12].map((offset) => (
        <g key={offset} opacity={0.4 + nightAmount * 0.6}>
          <rect
            x={width * offset}
            y={height * 0.7}
            width="5"
            height="13"
            rx="2.5"
            fill="#ffd18a"
          />
          <rect
            x={width * offset}
            y={height * 0.86}
            width="5"
            height="11"
            rx="2.5"
            fill="#e9bc79"
          />
        </g>
      ))}
      {[...roofs].reverse().map((roof) => (
        <g key={roof.y} transform={`translate(0 ${roof.y})`}>
          <path
            d={`M${-roof.width * 0.58} 9Q0 -4 ${roof.width * 0.58} 9L${roof.width * 0.5} 22Q0 36 ${-roof.width * 0.5} 22Z`}
            fill="#34485a"
          />
          <path
            d={`M${-roof.width * 0.58} 8 ${-roof.width * 0.36} -11Q0 -27 ${roof.width * 0.36} -11L${roof.width * 0.58} 8Q0 29 ${-roof.width * 0.58} 8Z`}
            fill="var(--yard-nearHill)"
            stroke="var(--yard-groundTop)"
            strokeWidth="2"
          />
          <ellipse
            cy="-11"
            rx={roof.width * 0.34}
            ry={roof.width * 0.11}
            fill="#243848"
            stroke="var(--yard-groundTop)"
            strokeWidth="4"
          />
          {[-0.22, -0.11, 0, 0.11, 0.22].map((slit) => (
            <path
              key={slit}
              d={`M${roof.width * slit} -17v12`}
              stroke="#718797"
              strokeWidth="2"
            />
          ))}
          <path
            d={`M${-roof.width * 0.48} 14Q0 31 ${roof.width * 0.48} 14`}
            fill="none"
            stroke="#eff7fc"
            strokeWidth="1.5"
            opacity="0.45"
          />
        </g>
      ))}
    </g>
  );

  return render();
};
